export const ProfileSectionType = Object.freeze({
  accountantsDetails: 'accountants-details',
  assetsToFinance: 'assets-to-finance',
  basicCompanyDetails: 'basic-company-details',
  commercialProperty: 'commercial-property',
  companyCredit: 'company-credit',
  director: 'director-or-secretary-details',
  documents: 'documents',
  eposTerminalInfo: 'epos-terminal-info',
  guarantorAssetsForSecurity: 'profile-guarantor-assets-for-security',
  invoiceFinancingProfile: 'invoice-financing',
  leadQualification: 'lead-qualification',
  significantOwners: 'shareholders',
  topInvoiceDebtors: 'top-invoice-debtors',
  tradeFinanceProfile: 'trade-finance-profile',
  tradeHistory: 'trade-history',
  tradeReferences: 'trade-references',
  estimatedServiceability: 'estimated-serviceability',
  creditProfile: 'credit-profile',
});

export const ProfileEnabledSections = Object.freeze({
  [ProfileSectionType.basicCompanyDetails]: true,
  [ProfileSectionType.commercialProperty]: true,
  [ProfileSectionType.director]: true,
  [ProfileSectionType.guarantorAssetsForSecurity]: true,
  [ProfileSectionType.significantOwners]: true,
  [ProfileSectionType.tradeHistory]: true,
  [ProfileSectionType.creditProfile]: true,
});

export const ProfileSectionTypeLabel = Object.freeze({
  [ProfileSectionType.accountantsDetails]: 'Accountant Details',
  [ProfileSectionType.assetsToFinance]: 'Assets to Finance',
  [ProfileSectionType.basicCompanyDetails]: 'Company Details',
  [ProfileSectionType.commercialProperty]: 'Property to Finance',
  [ProfileSectionType.companyCredit]: 'Company Credit Profile',
  [ProfileSectionType.director]: 'Directors and Significant Owners',
  [ProfileSectionType.documents]: 'Documents',
  [ProfileSectionType.eposTerminalInfo]: 'Credit Card Terminal Information',
  [ProfileSectionType.guarantorAssetsForSecurity]: "Guarantor's Assets for Security",
  [ProfileSectionType.invoiceFinancingProfile]: 'Invoice Financing Profile',
  [ProfileSectionType.leadQualification]: 'Background and Funding Purpose',
  [ProfileSectionType.significantOwners]: 'Significant Owners',
  [ProfileSectionType.topInvoiceDebtors]: 'Current Top Invoice Debtors',
  [ProfileSectionType.tradeFinanceProfile]: 'Trade Finance Profile',
  [ProfileSectionType.tradeHistory]: 'Trading History',
  [ProfileSectionType.tradeReferences]: 'Trade References',
  [ProfileSectionType.estimatedServiceability]: 'Estimated Serviceability',
});

export const ProfileSectionOrder = [
  ProfileSectionType.leadQualification,
  ProfileSectionType.basicCompanyDetails,
  ProfileSectionType.tradeHistory,
  ProfileSectionType.estimatedServiceability,
  ProfileSectionType.director,
  ProfileSectionType.guarantorAssetsForSecurity,
  ProfileSectionType.companyCredit,
  ProfileSectionType.tradeReferences,
  ProfileSectionType.eposTerminalInfo,
  ProfileSectionType.topInvoiceDebtors,
  ProfileSectionType.tradeFinanceProfile,
  ProfileSectionType.assetsToFinance,
  ProfileSectionType.invoiceFinancingProfile,
  ProfileSectionType.commercialProperty,
  ProfileSectionType.documents,
  ProfileSectionType.accountantsDetails,
  ProfileSectionType.creditProfile,
];

export const ProfileSectionKeys = Object.freeze({
  'accountant-details': 'accountant-details',
  'asset-to-finance': 'asset-to-finance',
  'company-details': 'company-details',
  'credit-card-information': 'credit-card-information',
  'director-details': 'director-details',
  'credit-profile': 'credit-profile',
  documents: 'documents',
  'background-and-purpose': 'background-and-purpose',
  'asset-for-security': 'asset-for-security',
  'invoice-finance': 'invoice-finance',
  'property-finance': 'property-finance',
  'trade-finance': 'trade-finance',
  'trading-history': 'trading-history',
  'required-documents': 'required-documents',
})

export const ProfileSectionKeyLabel = Object.freeze({
  'accountant-details': "Accountant's details",
  'asset-to-finance': 'Assets to finance',
  'company-details': 'Company Details',
  'credit-card-information': 'Credit Card Terminal Information',
  'director-details': 'Director details',
  'credit-profile': 'Company credit profile',
  documents: 'Documents',
  'background-and-purpose': 'Background and purpose',
  'asset-for-security': 'Guarantor Assets for Security',
  'invoice-finance': 'Invoice finance',
  'property-finance': 'Property to finance',
  'trade-finance': 'Trade finance',
  'trading-history': 'Trading history',
});
